import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { EditAdminDeductionRequest } from '@billda/api';
import { editAdminDeduction } from '../api/deductionsAdminApi';
import { deductionsKeys } from './useGetDeductions';
import { potKeys } from './potKeys';

/**
 * Mutation hook for editing an admin deduction.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useEditAdminDeduction() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      deductionId,
      request,
    }: {
      deductionId: string;
      request: EditAdminDeductionRequest;
    }) => editAdminDeduction(deductionId, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deductionsKeys.all });
      queryClient.invalidateQueries({ queryKey: potKeys.all });
    },
  });
}
